<template>
  <v-flex d-flex text-xs-center sticky>
    <v-scroll-y-transition mode="out-in">
      <div
        v-if="!selected"
        class="title grey--text text--lighten-1 font-weight-light"
        style="align-self: center;"
      >Sélectionner étudiant</div>
      <v-card v-else :key="selected._id" class="pt-4 mx-auto" flat max-width="400">
        <v-card-text>
          <h3 class="headline mb-2">{{ selected.firstName }} {{selected.lastName}}</h3>
          <div class="blue--text mb-2">{{ selected.email }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-layout tag="v-card-text" text-xs-left wrap>
          <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Semestre:</v-flex>
          <v-flex mr-5>{{ selected.semester }}</v-flex>
          <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Classe:</v-flex>
          <v-flex mr-5>{{ selected.class || 'n/a' }}</v-flex>
          <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Bulletin:</v-flex>
          <v-flex>
            <a @click="downloadReport">Télécharger</a>
          </v-flex>
          <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>ID du modèle:</v-flex>
          <v-flex>{{selected.modeleId}}</v-flex>
          <v-flex tag="strong" xs5 text-xs-right mr-3 mb-2>Généré le:</v-flex>
          <v-flex>{{selected.generatedAt | formatDate}}</v-flex>
          <v-flex v-if="selected.sentAt" tag="strong" xs5 text-xs-right mr-3 mb-2>Envoyé le:</v-flex>
          <v-flex v-if="selected.sentAt">{{selected.sentAt | formatDate}}</v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-text>
          <v-tooltip bottom>
            <v-btn
              flat
              icon
              slot="activator"
              color="grey-darken-3"
              @click="this.toggleUpdateDialog"
              :disabled="updating"
            >
              <v-icon dark>update</v-icon>
            </v-btn>
            <span>Mettre à jour le bulletin</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              :disabled="updating"
              icon
              slot="activator"
              color="grey-darken-3"
              @click="toggleSendOneDialog"
            >
              <v-icon dark>send</v-icon>
            </v-btn>
            <span>Envoyer le bulletin</span>
          </v-tooltip>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-btn
            v-if="!histories"
            :disabled="historiesLoading"
            flat
            @click="loadHistoryAsync(selected._id)"
          >Charger l'historique</v-btn>
          <div v-else>
            <div v-for="history in histories" :key="history.folderId">
              {{history.dateSent | formatDate }} :
              <a @click="downloadHistory(history.folderId, history.messageId)">bulletin</a>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-scroll-y-transition>
  </v-flex>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  data: () => ({
    histories: undefined,
    historiesLoading: false
  }),
  props: [
    "selected",
    "updating",
    "toggleUpdateDialog",
    "toggleSendOneDialog",
    "setUpdating",
    "setStudent",
    "openMessage",
    "active"
  ],
  methods: {
    downloadReport: async function() {
      const { data } = await axios({
        url: `${process.env.VUE_APP_API_URL}/reports/${this.active[0]}`,
        method: "GET",
        responseType: "blob"
      });
      const file = new Blob([data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(url);
    },
    downloadHistory: async function(folderId, messageId) {
      const { data } = await axios({
        url: `${process.env.VUE_APP_API_URL}/folders/${folderId}/messages/${messageId}`,
        method: "GET",
        responseType: "blob"
      });
      const file = new Blob([data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(url);
    },
    loadHistoryAsync: async function(_id) {
      this.historiesLoading = true;
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/students/${_id}/reports`
      });
      this.histories = data;
      this.historiesLoading = false;
    }
  },
  filters: {
    formatDate: function(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    }
  },
  watch: {
    selected: function() {
      this.histories = undefined;
    }
  }
};
</script>

